"use strict";

exports.__esModule = true;
var _TicketTypeRoutes = require("./TicketTypeRoutes");
Object.keys(_TicketTypeRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketTypeRoutes[key]) return;
  exports[key] = _TicketTypeRoutes[key];
});